/* global axios */
import ApiClient from '../ApiClient';

class AiAgentTools extends ApiClient {
  constructor() {
    super('ai_agents/tools', { accountScoped: true });
  }

  update(id, data, { changeConfirmed = false } = {}) {
    return axios.patch(`${this.url}/${id}`, {
      tool: data,
      change_confirmed: changeConfirmed,
    });
  }

  delete(id, { changeConfirmed = false } = {}) {
    return axios.delete(`${this.url}/${id}`, {
      params: { change_confirmed: changeConfirmed },
    });
  }
}

export default new AiAgentTools();
